import * as React from 'react';
import type { ReactNode } from 'react'

interface Props {
  children?: ReactNode
  id: string
  value: string
}

export function TabPanel(props: Props) {
  const { children, value, id } = props

  return (
    <div
      data-id="tidal-stories-tab-panel"
      role="tabpanel"
      hidden={value !== id}
      style={{ height: '100%', maxHeight: '100%', overflowY: 'auto', padding: 8 }}
    >
      {children ?? null}
    </div>
  )
}
